import React from 'react'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'

const About = styled.div`
  max-width: 60%;
  line-height: 2em;
  margin: 0 auto;
`

export function AboutPage({ data }) {

  return (
    <Layout>
      <SEO title="About" />

        <About>
            <h2>Over Gutsy</h2>
            
            {data && data.prismicAboutPage &&
                <div dangerouslySetInnerHTML={{ __html: data.prismicAboutPage.data.about.html }} />
            }
        </About>
    </Layout>
  )
}

export const query = graphql`
    query about {
        prismicAboutPage {
            data {
                about {
                    html
                }
            }
        }
    }
`

export default AboutPage
